<script>
import CrudList from 'Arch/components/crud/CrudList.vue';
import QuestionsRequest from 'Modules/contacard/faq/questions/QuestionsRequest';
import DataTableCheckBoxColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableCheckBoxColumn.vue';
import DataTableGetByIdRowVue from './component/DataTableGetByIdRow.vue';

export default {
  name: 'QuestionsCrudList',
  extends: CrudList,
  data: () => ({
    requestClass: QuestionsRequest,
    editRoute: 'contacard.faq.questions.edit',
    headers: [
      {
        text: 'Data de cadastro',
        value: 'createdAt',
        component: 'DataTableDateColumn',
        width: '5%',
      },
      {
        text: 'Ordem',
        value: 'order',
      },
      {
        text: 'Pré-login',
        value: 'isPreLogin',
        component: DataTableCheckBoxColumnVue,
      },
      {
        text: 'Pergunta',
        value: 'question',
        width: '40%',
        options: {
          shouldWrap: true,
        },
      },
      {
        text: 'Resposta',
        value: 'answer',
        width: '40%',
        options: {
          shouldWrap: true,
        },
      },
      {
        text: 'Categoria',
        value: 'categoryId',
        width: '15%',
        component: DataTableGetByIdRowVue,
      },
    ],
  }),
  methods: {
  },
};
</script>
